import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { LoggingService, LogEntry, LogLevel } from '../../services/logging.service';

@Component({
  selector: 'app-debug-dashboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './debug-dashboard.component.html',
  styleUrls: ['./debug-dashboard.component.css']
})
export class DebugDashboardComponent implements OnInit {
  logs$: Observable<LogEntry[]>;
  LogLevel = LogLevel;

  constructor(private loggingService: LoggingService) {
    this.logs$ = this.loggingService.getLogs();
  }

  ngOnInit(): void {}

  getLogLevelName(level: LogLevel): string {
    return LogLevel[level];
  }
}
